// src/lib/utility/environment.ts

import { get } from "svelte/store";
import { environment, version } from "$lib/stores/environmentStore";
import { browser, dev } from "$app/environment";

export function isDevelopment(): boolean {
  return dev;
}

export function isStaging(): boolean {
  if (browser) {
    return get(environment) === "staging";
  } else {
    return process.env.ENVIRONMENT === "staging";
  }
}

export function isProduction(): boolean {
  if (browser) {
    return get(environment) === "production";
  } else {
    return process.env.ENVIRONMENT === "production";
  }
}

export function isNotProduction(): boolean {
  return isDevelopment() || isStaging();
}

export function getContainerVersion(): string {
  if (browser) {
    return get(version) || "";
  } else {
    return process.env.VERSION || "";
  }
}

export const env = {
  isDevelopment,
  isStaging,
  isProduction,
  isNotProduction,
};
